import { ManualInputs } from "src/store/createJobRotationAssessmentSlice";
import { CompletedAssessmentInfo } from "src/store/jobRotationAssessmentLibrarySlice";
import exportSmallTokens from "@amzn/meridian-tokens/base/icon/export-small";
import wristIcon from "src/images/wrist.png";
import neckIcon from "src/images/neck.png";
import trunkIcon from "src/images/trunk.png";
import lowerArmIcon from "src/images/lower_arm.png";
import upperArmIcon from "src/images/upper_arm.png";
export const COMPLETED_ASSESSMENT_HEADERS = [
  "Assessment Name",
  "Site",
  "Site Type",
  "Process Path",
  "Job Pairings",
  "Score",
  "Last updated",
  "Updated by",
];
export const COMPLETED_ASSESSMENT_HEADERS_V2 = [
  "Assessment Name",
  "Site",
  "Site Type",
  "Process Path",
  "Job Pairings",
  "Trunk Score",
  "Upper Arm Score",
  "Last updated",
  "Updated by",
];
export const DRAFT_ASSESSMENT_HEADERS = [
  "Assessment Name",
  "Site",
  "Site Type",
  "Process Path",
  "Status",
  "Last updated",
  "Updated by",
  "", // Left empty for no header content (menu meatballs icon)
];

export const uploadVideoErrorMessages = {
  videoAlreadyExist:
    "A video with the same file name already exists in the list below. Please select a different video.",
  numberOfVideosLimitPassed:
    "Only 8 videos can be uploaded for an assessment. Please try again within the limit.",
  someVideosExist:
    "One or more selected videos already exists in the list below. Additional videos have been added successfully",
  maxVideosNumberReached: "Maximum number of videos added",
  uploadingVideo:
    "Uploading in progress, please wait and do not close the current tab...  ",
  uploadSuccess: "All videos uploaded successfully",
};

export const HOLD_TIME_BEFORE_NAVIGATE = 3000;
export const MAX_VIDEOS_UPLOADABLE = 8;
export const MAX_VIDEO_UPLOAD_RETRIES = 3;
export const MINIMUM_COMPLETED_ASSESSMENTS_FOR_JOB_PAIRING = 5;
export const uploadingStatus = {
  PENDING: "Pending...",
  UPLOADING: "Uploading...",
  UPLOADED: "Uploaded",
  UPLOAD_FAILED: "Upload failed",
};
export const THIRTY_MINUTES_IN_SECONDS = 1800;
export const assessmentFromAPIStatus = {
  PROCESSING: "PROCESSING",
  DRAFT: "DRAFT",
  ERROR: "ERROR",
  DONE: "DONE",
};
export const draftAssessmentForUIStatus = {
  Processing: "Processing...",
  Draft: "Draft",
  Error: "Error",
};
export const videoScreenViewMode = {
  SMALL_VIEW: "small-view",
  REGULAR_VIEW: "regular-view",
  MODAL_VIEW: "modal-view",
};
export const taskToBeCompletedStatus = {
  COMPLETED: "completed",
  STARTED: "started",
  NOT_STARTED: "not-started",
};
export const tasksToBeCompletedLabels = {
  UPLOAD_VIDEOS: "Upload Videos(s)",
  ADD_WORK_CYCLE_SEGMENTS: "Add Active Work Segments",
  ADD_MANUAL_ASSESSMENT: "Add Manual Inputs",
};
export const ZERO = 0;
export const createAssessmentWorkFlowCases = {
  UPLOAD_VIDEOS: "Upload Videos",
  ADD_WORK_CYCLE_SEGMENTS: "Add Active Work Segmments",
  ADD_MANUAL_ASSESSMENTS: "Add Manual Inputs",
};
export const jobRotationPages = {
  CREATE_ASSESSMENT: "/createJobRotationAssessment",
  VIEW_ASSESSMENT_LIBRARY: "/jobRotationAssessmentLibrary",
  ASSESSMENT_DETAILS: "/jobRotationAssessmentDetails",
  DRAFT_ASSESSMENT_DETAILS: "/draftAssessmentDetails",
};
export const createWorkCycleSegmentErrorMessage = {
  FILL_BOTH_STARTIME_AND_ENDTIME:
    "No work cycle segment created to add. Please mark start time and end time to create.",
  ENDTIME_MUST_BE_GREATER: "End time must be greater than start time!",
};
export const MANUAL_INPUT_LABELS = [
  "Hours in Process Path per Day*",
  "Intensity of Work*",
  "Count of movements OUT of Neutral*",
  "% of Time OUT of Neutral*",
  "% of Time in Twisting*",
  "Intensity of Work*",
  "% of Time in Twisting*",
  "Intensity of Work*",
  "Intensity of Work*",
  "Hours in Process Path per Day*",
];
export const INITIAL_MANUAL_INPUT: ManualInputs = {
  durationPerDay: "",
  wristIntensityOfExertion: "",
  wristNumberOfTimesMovingOutOfNeutral: "",
  wristPercentageOfTimeOutOfNeutral: "",
  neckPercentageOfTimeTwisting: "",
  trunkIntensityOfExertion: "",
  trunkPercentageOfTimeTwisting: "",
  upperArmIntensityOfExertion: "",
  lowerArmIntensityOfExertion: "",
};
export const INITIAL_MANUAL_INPUT_V2: ManualInputs = {
  durationPerDayV2: "",
  trunkIntensityOfExertion: "",
  upperArmIntensityOfExertion: "",
};
export const playPauseButtonConstants = {
  WIDTH: 30,
  HEIGHT: 30,
  PAUSE_BAR_WIDTH: 5,
  PAUSE_BAR_VERTICAL_PADDING: 2,
  PAUSE_BAR_SPACING: 6,
};
export const jobRotationVideoStatus = {
  UPLOADING: "UPLOADING",
  PROCESSING: "PROCESSING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};
export const deleteDraftAssmentModalData = {
  modalTitle: "Confirm deletion",
  messageHeading: "Delete this draft assessment?",
  messageContent:
    "This action can't be undone. The selected draft assessment will be permanently removed.",
  successActionLabel: "Delete",
};
export const defaultAssessmentSite = "ABE2";
export const assessmentInfoKeyMapping = {
  site: "Site",
  siteType: "Site Type",
  processPath: "Process Path",
  country: "Country",
  region: "Region",
  org: "Organization",
  suborg: "Sub-Org",
};
export const assessmentStrainIndexMapping = {
  wrist: { label: "Wrist", imagePath: wristIcon },
  neck: { label: "Neck", imagePath: neckIcon },
  trunk: { label: "Trunk", imagePath: trunkIcon },
  lowerArm: { label: "Lower armt", imagePath: lowerArmIcon },
  upperArm: { label: "Upper arm", imagePath: upperArmIcon },
};
export const assessmentStrainIndexMappingV2 = {
  trunk: { label: "Trunk", imagePath: trunkIcon },
  upperArm: { label: "Upper arm", imagePath: upperArmIcon },
};

export const strainIndexBodyDetailsMapping = {
  timeTwistingPct: "Time in Twisting",
  effortsPerMinute: "Effort per Minute",
  durationOfExertion: "Duration of Exertion",
  averagePosture: "Average Posture",
  intensityOfExertion: "Intensity of Exertion*",
  numTimesOutOfNeutral: "Count of movements OUT of Neutral",
  timeOutOfNeutralPct: "% Time OUT of Neutral",
};
export const strainIndexBodyDetailsMappingV2 = {
  effortsPerMinute: "Effort per Minute",
  durationOfExertion: "Duration of Exertion",
  averagePosture: "Average Posture",
  intensityOfExertion: "Intensity of Work*",
};

export const baseCompletedAssessment: CompletedAssessmentInfo = {
  assessmentId: "",
  assessmentName: "",
  site: "",
  processPath: "",
  status: "",
  dateCreated: "",
  dateUpdated: "",
  updatedBy: "",
  strainIndexScore: 0,
  numComplementaryJobs: 0,
  trunkScore: 0,
  upperArmScore: 0,
  complementaryJobs: [],
};
export const resourcesData = [
  {
    text: "User Guide",
    path: "https://w.amazon.com/bin/view/WHS/TECH/ght/ergona/Userguide/",
    icon: exportSmallTokens,
    isResourceLink: true,
  },
  {
    text: "Demo Videos",
    path: "https://broadcast.amazon.com/channels/78338 ",
    icon: exportSmallTokens,
    isResourceLink: true,
  },
  {
    text: "RIVER Intake",
    path: "https://river.amazon.com/?org=PI3%20-%20WW&buildingId=VCO&q0=0602a648-8cde-4982-bd1f-fddfc032798d ",
    icon: exportSmallTokens,
    isResourceLink: true,
  },
  {
    text: "Consent Form",
    path: "https://drive.corp.amazon.com/personal/harivit/Ergona%20Consent%20Forms ",
    icon: exportSmallTokens,
    isResourceLink: true,
  },
];
export const JR_ERRORS_MAPPINGS = {
  INFERENCE_INTERNAL_ERROR: {
    errorTitle: "Software processing error.",
    errorContent:
      "This video could not be processed due to a technical issue with the software. Please create a new assessment and re-submit your videos.",
  },
  VIDEO_RESOLUTION_ERROR: {
    errorTitle: "Low video resolution.",
    errorContent:
      "Please ensure the video has greater than 512x512 p resolution by checking the video properties prior to upload. Note: video resolution can be reduced during file transfer from mobile device to desktop. Re-record as necessary.",
  },
  VIDEO_DURATION_ERROR: {
    errorTitle: "Invalid video duration.",
    errorContent:
      "Please ensure the video length is between 3 sec - 5 min. Re-record video as necessary.",
  },
  FACE_NOT_DETECTED_ERROR: {
    errorTitle: "The person’s face was not detected.",
    errorContent:
      "Please ensure the person being recorded is fully visible and facing the camera at the start of the video. We recommend having the person face the camera and hold a neutral body position for 1 - 2 seconds before continuing through the standard work.",
  },
  UPLOAD_ERROR: {
    errorTitle: "Video upload error.",
    errorContent:
      "Please create a new assessment and re-upload all videos. Do not exit or refresh the web page until you receive a success message when upload completes.",
  },
  PERSON_MISSING_ERROR: {
    errorTitle:
      "The person being recorded was not fully in view for the entire video.",
    errorContent:
      "Please ensure the person’s entire body remains visible throughout the recording and the person is not partially or fully hidden behind any objects for any amount of time. Re-record as necessary.",
  },
  LOW_FPS_ERROR: {
    errorTitle: "Low frames per second.",
    errorContent:
      "Please ensure your camera is set to record using 10 frames per second (FPS) or greater. This is a device setting and ensures the video quality meets minimum requirements for processing. Re-record your video and submit when ready.",
  },
  VIDEO_TRANSFORMATION_ERROR: {
    errorTitle: "Software processing error.",
    errorContent:
      "This video could not be processed due to a technical issue with the software. Please create a new assessment and re-submit your videos.",
  },
  UNREADABLE_VIDEO_ERROR: {
    errorTitle: "Video upload error.",
    errorContent:
      "Please create a new assessment and re-upload all videos. Do not exit or refresh the web page until you receive a success message when upload completes.",
  },
  VIDEO_QUALITY_ERROR: {
    errorTitle: "Video quality error.",
    errorContent: "",
  },
};
export const JR_HOVER_OVER_MESSAGES = {
  IntensityOfWork_trunk:
    "Choose the input that best represents how strenuous the process path work appears to be with regards to the trunk.",
  IntensityOfWork_upperArm:
    "Choose the input that best represents how strenuous the process path work appears to be with regards to the upper arm and shoulder joint.",
  HoursInProcessPathPerDay:
    "Select the closest input for how long an Associate typically works in this process path for a given day.",
  JobRotationExposureIndex:
    "These scores are used to compare process paths at the site level to determine job pairings for reducing physical stress on the body.",
  RecommendedJobPairings:
    "Process paths listed here are mutually beneficial for job rotation with the process path on this page. These are ordered by most recommended on the top of the list and do not include operational feasibility factors.",
  VideosAndActiveWorkSegments:
    "Add “active work segments” to each video to specify which video frames to include in assessment calculations. Any video frames NOT included in an active work segment will be ignored in calculations. The optional checkbox below will default to consider all video frames in calculations without the need to add individual segments.",
};
